
import DropdownBubble from '@/common/components/DropdownBubble.vue';
import LogoutButton from '@/common/components/LogoutButton.vue';
import viewTypes from '@/common/helpers/view-types';
import { SvgIcon } from '@samknows/design-system';
import { prefStorage } from '@samknows/utils';
import { defineComponent } from 'vue';
import { Accessibles } from '@/common/services/account/types';
import { goToView } from '@/common/services/account/userNavigation';

export default defineComponent({
  components: {
    DropdownBubble,
    SvgIcon,
    LogoutButton
  },
  props: {
    display: {
      type: Boolean,
      required: true
    },
    verticalOffset: {
      type: Object,
      required: true
    },
    pxWrapperRight: {
      type: String,
      required: true
    },
    pointerOrientation: {
      type: String,
      required: true
    },
    pxPointerPosition: {
      type: String,
      required: true
    }
  },
  data: () => ({
    activeView: viewTypes.activeView,
    accessibles: prefStorage.get<Accessibles>('accessibles'),
    spinnerId: 0 as string | number
  }),
  methods: {
    showLanguageSwitcher() {
      this.$store.commit('languageSwitcher/SET_VISIBILITY', true);
    },
    switchToWhitebox(box) {
      this.spinnerId = box.unitId;
      this.switchToView('units', box);
    },
    switchToView(type, data) {
      goToView(type, data);
    },
    selectLanguageClicked() {
      this.showLanguageSwitcher();
    }
  }
});
